import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    createFetchParams: (startDate, endDate, filters) => {
        const params = {
            ci_class:   filters.ciClass.join(','),
            operable:   filters.operable,
            start_date: Math.floor(startDate / TIMESTAMP_MULTIPLY),
            end_date:   Math.floor(endDate / TIMESTAMP_MULTIPLY)
        };

        return params;
    },
    ...storeModuleFactory({
        name:               'monitoringActiveClosedEvents',
        endpoint:           endpoints.monitoring.eventsTotal,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_SMALL,
        transformResultsFn: results => ({
            active:      results.active,
            closed:      results.closed,
            totalEvents: results.total_events,
            lastSync:    results.last_sync
        })
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/monitoringActiveClosedEvents.js